import React from 'react';
import styled from 'styled-components';
import BottomSheet from 'components/_UI/BottomSheet';
import colors from 'theme/colors';

function formatPrice(value) {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function PublicProductSheet({ product, onClose }) {
    return (
        <BottomSheet isOpen={true} onClose={onClose} title={product.name} size='large'>
            {product.image && (
                <HeroImage
                    src={product.image.path || product.image.thumb}
                    alt={product.name}
                    onError={e => { e.target.onerror = null; e.target.src = '/assets/images/placeholder-events.png'; }}
                />
            )}

            {product.description && (
                <ProductDescription>{product.description}</ProductDescription>
            )}

            <PriceTag>{formatPrice(product.base_price)}</PriceTag>

            {product.option_groups?.length > 0 && (
                <OptionsSection>
                    <OptionsSectionTitle>Opcionais</OptionsSectionTitle>
                    {product.option_groups.map(group => (
                        <GroupBlock key={group.id}>
                            <GroupTitle>
                                {group.name}
                                {group.is_required && <RequiredTag> · Obrigatório</RequiredTag>}
                            </GroupTitle>
                            {group.options.map(opt => (
                                <OptionRow key={opt.id}>
                                    <OptionName>{opt.name}</OptionName>
                                    {Number(opt.price_adjustment) > 0 && (
                                        <OptionPrice>+{formatPrice(opt.price_adjustment)}</OptionPrice>
                                    )}
                                </OptionRow>
                            ))}
                        </GroupBlock>
                    ))}
                </OptionsSection>
            )}
        </BottomSheet>
    );
}

/* Styled Components */

const HeroImage = styled.img`
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 12px;
    margin-bottom: 14px;
`;

const ProductDescription = styled.p`
    font-size: 14px;
    color: ${colors.nightLight};
    line-height: 1.6;
    margin: 0 0 12px;
`;

const PriceTag = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: ${colors.occasionalPurple};
    margin-bottom: 20px;
`;

const OptionsSection = styled.div`
    border-top: 1px solid ${colors.neutralDark};
    padding-top: 16px;
`;

const OptionsSectionTitle = styled.h4`
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${colors.nightLight};
    margin: 0 0 12px;
`;

const GroupBlock = styled.div`margin-bottom: 16px;`;

const GroupTitle = styled.p`
    font-size: 14px;
    font-weight: 700;
    color: ${colors.nightDark};
    margin: 0 0 8px;
`;

const RequiredTag = styled.span`
    font-weight: 400;
    font-size: 12px;
    color: ${colors.danger};
`;

const OptionRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9px 0;
    border-bottom: 1px solid ${colors.neutralDark};
    &:last-child { border-bottom: none; }
`;

const OptionName = styled.span`font-size: 14px; color: ${colors.nightDark};`;
const OptionPrice = styled.span`font-size: 14px; font-weight: 600; color: ${colors.occasionalPurple};`;
